import ApiService from "@services/api.service";
import {Notify} from 'quasar';
export const etudiantSessions = {
  state: {
    sessions: [],
    session: null,
    countEtudiantBySession: {}, // { [sessionId]: count }
  },
  mutations: {
    setSessions(state, sessions){
      state.sessions = sessions;
    },
    setSession(state, session){
      state.session = session;
    },
    setCountEtudiantForSession(state, { sessionId, count }) {
      state.countEtudiantBySession = { ...state.countEtudiantBySession, [sessionId]: count };
    },
  },
  actions: {
    async fetchCountEtudiantSession(context, sessionId){
      try{
        const response = await ApiService.getRequest(`stagiaires_session/${sessionId}`)
        context.commit('setCountEtudiantForSession', { sessionId, count: response.data.count });
        return response.data.count;
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },
    /*Récupère l'ensemble des stagiaires en fonction de leur diplômes et de de l'antenne
      Pour les sessions des diplômes ou des actions de formations
     */
    async fetchEtudiantSessions(context, data){
      const params = { antenne: data.antenne }
      if (data.action) {
        params.action = data.action
      } else if (data.diplome) {
        params.diplome = data.diplome
      }

      return await ApiService.getRequest('/session_stagaires_list', params).then(
        response => {
          context.commit('setSessions', response.data['hydra:member']);
        }
      ).catch(error => {
        console.error(error);
        Notify.create({
          messsage: "Une erreur s'est produite lors de la récupération des stagiaires",
          color: 'red'
        })
      })
    },
    /*
      Ajoute une session pour la gestion des groupes
    */
    async addSessionEtudiant(context, formData){
      try{
        const response = await ApiService.postRequest('antenne_groupe_sessions', formData);
        context.commit('setSession', response.data);
        Notify.create({
          message: `${response.data.name} a été ajoutée avec succès`,
          color: 'green'
        })
      }catch (error) {
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout de la session",
          color: 'red'
        })
      }
    },
    //Modifie une session de la gestion des groupes
    async updateSession(context, data){
      try{
        const response = await ApiService.patchRequest(data.url, data.formData);
        context.commit('setSession', response.data);

        if(response.status === 200 ){
          Notify.create({
            message: `${response.data.name} modifiée avec succès`,
            color: 'green'
          })
        }
      }catch (error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produitelors de la modifiaction de la session",
          color: 'red'
        })
      }
    },
    // Ajoute la liste des stagiaires par rapport à un groupe séléctionné
    async updateSessionListEtudiant(context, data){
      try{
        const response = await ApiService.patchRequest(data.url, data.groupe);
        context.commit('setSession', response.data);

        if(response.status === 200){
          Notify.create({
            message: 'Session modifiée avec succès',
            color: 'green'
          })
        }
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de la modification",
          color: 'red'
        })
      }
    },
    //Ajoute les stagiaires en les transferant un à un
    async updateSessionEtudiant(context, data){
      try{
        const response = await ApiService.patchRequest(data.url, data.stagiaire);
        context.commit('setSession', response.data);

        if(response.status === 200){
          Notify.create({
            message: 'Session modifiée avec succès',
            color: 'green'
          })
        }
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de la modification",
          color: 'red'
        })
      }
    },
    //TRANSFERT D'UN STAGIAIRE D'UNE SESSION À L'AUTRE
    async transfereEtudiantSession(context, data){
      try{
        const response = await ApiService.postRequest(data.url, data.formData);
        context.commit('setSession', response.data);

        if(response.status === 201){
          Notify.create({
            message: "Le bénéficiaire a été tranféré avec succès",
            color: 'green'
          })
        }
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors du transfere du bénéficiaire",
          color: 'red'
        })
      }
    }
  },
  getters: {
    getSessions(state){
      return state.sessions;
    },
    getSession(state){
      return state.session;
    },
    getCountEtudiantBySession: (state) => (sessionId) => state.countEtudiantBySession[sessionId],
  }
}
